class ProductBundleOptions extends HTMLElement {
  connectedCallback() {
    if (this.dataset.bundleReady === 'true') return;

    this.formId = this.dataset.productFormId;

    if (!this.formId) return;

    this.initAttempts = 0;
    this.initialize();
  }

  initialize() {
    if (this.dataset.bundleReady === 'true') return;

    this.form = document.getElementById(this.formId);

    /*
     * O bundle pode aparecer no DOM antes do product form.
     * Nesse caso, tentamos novamente no próximo frame.
     */
    if (!this.form) {
      this.initAttempts += 1;

      if (this.initAttempts <= 10) {
        requestAnimationFrame(() => {
          if (this.isConnected) {
            this.initialize();
          }
        });
      }

      return;
    }

    /*
     * Só marcamos como inicializado DEPOIS
     * que o formulário foi encontrado.
     */
    this.dataset.bundleReady = 'true';

    this.radios = Array.from(
      this.querySelectorAll('[data-bundle-radio]')
    );

    this.items = Array.from(
      this.querySelectorAll('[data-bundle-option]')
    );

    this.hiddenState = this.querySelector(
      '[data-bundle-selected-quantity]'
    );

    this.ensureVariantInput();
    this.ensureQuantityInput();
    this.bindEvents();
    this.syncSelectedOption();
  }

  ensureVariantInput() {
    this.variantInput = this.form.querySelector(
      'input[name="id"]'
    );

    if (!this.variantInput && this.formId) {
      this.variantInput = document.querySelector(
        `input[name="id"][form="${this.formId}"]`
      );
    }
  }

  ensureQuantityInput() {
    this.quantityInput = this.form.querySelector(
      'input[name="quantity"]'
    );

    if (!this.quantityInput && this.formId) {
      this.quantityInput = document.querySelector(
        `input[name="quantity"][form="${this.formId}"]`
      );
    }

    /*
     * Se não existir quantity no product form,
     * criamos um input hidden dentro dele.
     */
    if (!this.quantityInput) {
      this.quantityInput = document.createElement('input');
      this.quantityInput.type = 'hidden';
      this.quantityInput.name = 'quantity';
      this.quantityInput.value = '1';

      this.form.appendChild(this.quantityInput);
    }
  }

  bindEvents() {
    /*
     * O próprio <label> já seleciona o radio.
     * Não precisamos de click artificial no item.
     *
     * Isso evita:
     * click -> sync
     * radio change -> sync novamente
     */
    this.addEventListener('change', (event) => {
      if (!event.target.matches('[data-bundle-radio]')) return;

      this.syncSelectedOption();
    });
  }

  syncSelectedOption() {
    const checkedRadio = this.querySelector(
      '[data-bundle-radio]:checked'
    );

    if (!checkedRadio) return;

    const currentItem = checkedRadio.closest(
      '[data-bundle-option]'
    );

    this.updateActiveState(currentItem);
    this.syncSelectedQuantity(checkedRadio);
    this.syncSelectedVariant(currentItem);
  }

  updateActiveState(currentItem) {
    this.items.forEach((item) => {
      item.classList.toggle(
        'is-active',
        item === currentItem
      );
    });
  }

  syncSelectedQuantity(checkedRadio) {
    if (!checkedRadio || !this.quantityInput) return;

    const qty = checkedRadio.value || '1';

    /*
     * Só altera o valor.
     *
     * NÃO dispara change artificial,
     * porque o product-form pega o valor
     * diretamente no FormData durante o submit.
     */
    this.quantityInput.value = qty;

    if (this.hiddenState) {
      this.hiddenState.value = qty;
    }
  }

  syncSelectedVariant(currentItem) {
    if (!currentItem || !this.variantInput) return;

    const variantId = currentItem.dataset.variantId;

    if (!variantId) return;

    /*
     * Mesma lógica:
     * atualiza o variant ID silenciosamente.
     *
     * O FormData pegará esse valor no submit.
     */
    this.variantInput.value = variantId;
  }
}

if (!customElements.get('product-bundle-options')) {
  customElements.define(
    'product-bundle-options',
    ProductBundleOptions
  );
}